import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useApi } from '../providers/ApiProvider';

export function JoinListPage() {
  const { code } = useParams<{ code: string }>();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const api = useApi();

  useEffect(() => {
    if (!code) return;

    api
      .joinList(code)
      .then((list) => {
        navigate(`/lists/${list.id}`, { replace: true });
      })
      .catch((err) => {
        setError(
          err && typeof err === 'object' && 'message' in err
            ? (err as { message: string }).message
            : 'Failed to join list. The invite link may be invalid or expired.'
        );
      });
  }, [code, api, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md w-full text-center space-y-4">
          <div className="bg-red-50 text-red-700 p-4 rounded-lg text-sm">
            {error}
          </div>
          <Link to="/" className="text-blue-600 hover:underline inline-block">
            Go to your lists
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-3">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
        <p className="text-gray-500 text-sm">Joining list...</p>
      </div>
    </div>
  );
}
